import { SiteState } from "../types/SiteState";
import { createSlice } from "@reduxjs/toolkit";
import { setSiteVisibility } from "../actions/setVisibility";
import { setInitVisibility } from "../actions/setInitVisibility";
import { addUsedHook } from "../actions/addUsedHook";

const initialState: SiteState = {
  data: {
    isOnline: false,
    isLocalOnline: false,
    anno: "",
    date: "",
  },
  hasError: false,
  checked: false,
  usedHooks: [],
};

export const siteSlice = createSlice({
  name: "site",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addUsedHook, (state, { payload }) => {
        state.usedHooks = [...state.usedHooks, payload];
      })
      .addCase(setInitVisibility, (state, { payload }) => {
        state.data.isOnline = payload.data.isOnline;
        state.data.isLocalOnline = payload.data.isLocalOnline;
        state.data.anno = payload.data.anno;
        state.data.date = payload.data.date;
        state.usedHooks = [];
        state.checked = payload.checked;
        state.hasError = payload.hasError;
      })
      .addCase(setSiteVisibility.fulfilled, (state, { payload }) => {
        state.data.isOnline =
          process.env.NODE_ENV === "development"
            ? state.data.isOnline
            : payload;
        state.data.isLocalOnline =
          process.env.NODE_ENV === "development"
            ? payload
            : state.data.isLocalOnline;
        state.usedHooks = ["useSiteState"];
        state.checked = true;
      })
      .addCase(setSiteVisibility.rejected, (state) => {
        state.hasError = true;
        state.checked = true;
        state.usedHooks = ["useSiteState"];
      });
  },
});
